import { render, staticRenderFns } from "./PageSide.vue?vue&type=template&id=dc1a8c0c&scoped=true&"
import script from "./PageSide.vue?vue&type=script&lang=js&"
export * from "./PageSide.vue?vue&type=script&lang=js&"
import style0 from "./PageSide.vue?vue&type=style&index=0&id=dc1a8c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1a8c0c",
  null
  
)

export default component.exports